import React, { useState, useEffect } from 'react';

const FrameContentsAdd = ({ onClose, onSave, initialData, isEditMode = false }) => {
  const [modalData, setModalData] = useState({
    name: '',
    data: '',
    type: '1cut_hor&2cut_ver',
    direction: 'landscape'
  });

  useEffect(() => {
    if (initialData) {
      setModalData({
        name: initialData.name,
        data: initialData.data || '',
        type: initialData.type === '1컷 가로 & 2컷 세로' ? '1cut_hor&2cut_ver' :
              initialData.type === '1컷 세로 & 2컷 가로' ? '1cut_ver&2cut_hor' :
              initialData.type === '3컷 세로 & 4컷 세로' ? '3cut_ver&4cut_ver' :
              '3cut_hor&4cut_hor',
        direction: initialData.direction === '가로' ? 'landscape' : 'portrait'
      });
    }
  }, [initialData]);

  const handleUpload = () => {
    // 실제 구현에서는 파일 업로드 로직 추가
    console.log('Upload frame data');
  };

  return (
    <div className="modal-overlay active">
      <div className="modal-container">
        <div className="modal-header">
          <h3 className="modal-title">프레임 {isEditMode ? '수정' : '추가'}</h3>
          <button className="modal-close" onClick={onClose}>
            <i className="ri-close-line"></i>
          </button>
        </div>
        <div className="modal-body">
          <div className="modal-content">
            <div className="modal-form-group">
              <div className="modal-row-container">
                <div className="modal-column">
                  <label className="modal-label">프레임명</label>
                  <input 
                    type="text" 
                    className="modal-input" 
                    id="frame-name" 
                    placeholder="프레임명을 입력하세요"
                    value={modalData.name}
                    onChange={(e) => setModalData(prev => ({ ...prev, name: e.target.value }))}
                  />
                </div>
                <div className="modal-column">
                  <label className="modal-label">프레임 데이터</label>
                  <div className="modal-import-with-button">
                    <input 
                      type="text" 
                      className="modal-input" 
                      id="frame-data" 
                      placeholder="URL"
                      value={modalData.data}
                      onChange={(e) => setModalData(prev => ({ ...prev, data: e.target.value }))}
                    />
                    <button 
                      className="modal-btn modal-btn-secondary" 
                      id="import-frame-btn"
                      onClick={handleUpload}
                    >
                      불러오기
                    </button>
                  </div>
                </div>
              </div>
              <div className="modal-data-image-frame">
                <img src="images/frameData/frame1.png" alt="frame" />
              </div>
              <div className="modal-form-group">
                <div className="modal-row-container">
                  <div className="modal-column">
                    <label className="modal-label">타입</label>
                    <div className="modal-select-container">
                      <select 
                        className="modal-select" 
                        id="angle-type"
                        value={modalData.type}
                        onChange={(e) => setModalData(prev => ({ ...prev, type: e.target.value }))}
                      >
                        <option value="1cut_hor&2cut_ver">1컷 가로 & 2컷 세로</option>
                        <option value="1cut_ver&2cut_hor">1컷 세로 & 2컷 가로</option>
                        <option value="3cut_ver&4cut_ver">3컷 세로 & 4컷 세로</option>
                        <option value="3cut_hor&4cut_hor">3컷 가로 & 4컷 가로</option>
                      </select>
                      <i className="ri-arrow-down-s-line modal-select-arrow"></i>
                    </div>
                  </div>
                  <div className="modal-column">
                    <label className="modal-label">방향</label>
                    <div className="modal-select-container">
                      <select 
                        className="modal-select" 
                        id="angle-direction"
                        value={modalData.direction}
                        onChange={(e) => setModalData(prev => ({ ...prev, direction: e.target.value }))}
                      >
                        <option value="landscape">가로</option>
                        <option value="portrait">세로</option>
                      </select>
                      <i className="ri-arrow-down-s-line modal-select-arrow"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="modal-btn modal-btn-cancel" onClick={onClose}>취소</button>
          <button className="modal-btn modal-btn-primary" onClick={() => onSave(modalData)}>확인</button>
        </div>
      </div>
    </div>
  );
};

export default FrameContentsAdd;
